import React, { useState } from "react";
import axios from "axios";
import { Container, TextField, Button, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  const handleForgotPassword = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await api.post("/api/auth/forgot-password", { email });
      setMessage(response?.data?.message ?? t('reset_link_sent'));
    } catch (error) {
      setMessage(t("reset_error", { error: error.response?.data?.error || t("reset_error") }));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={5}>
        <Typography variant="h4" gutterBottom>
          {t("forgot_password")}
        </Typography>
        <form onSubmit={handleForgotPassword}>
          <TextField
            label={t("email")}
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button variant="contained" color="primary" type="submit" fullWidth disabled={isSubmitting}>
            {isSubmitting ? t("sending") : t("send_reset_link")}
          </Button>
        </form>
        {message && (
          <Typography color={message.includes("Error") ? "error" : "primary"} mt={2}>
            {message}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default ForgotPassword;

